import React, { FC, ReactElement } from 'react';
import { useTheme } from '../../../../../theme';
import ModalConfirm from '../../../../../ModalConfirm';
import CdnImage from '../../../../../CdnImage';
import CopyButton from '../../../../../BaseComponents/Button/components/CopyButton/CopyButton';
import { ErrorDetail } from '@shared/error';

interface Props {
	isOpen: boolean;
	header?: string;
	title?: string;
	message?: string;
	details?: ErrorDetail[];
	detailsTitle?: string;
	detailsDescription?: string;
	detailsText?: string;
	confirmBtn?: ReactElement<Element> | string;
	cancelBtn?: ReactElement<Element> | string;
	onClose?: () => void;
	onConfirm?: () => void;
	onCancel?: () => void;
}

const ErrorModal: FC<Props> = ({
	isOpen,
	header,
	title,
	message,
	details,
	detailsTitle,
	detailsDescription,
	detailsText,
	confirmBtn,
	cancelBtn,
	onClose,
	onConfirm,
	onCancel
}) => {
	const { ErrorModal: theme } = useTheme('Shared');

	const showErrorInfo = !!title || !!message;
	const showDetails = !!details?.length && !!detailsText;

	return (
		<ModalConfirm
			classes={{
				container: theme.modal__container,
				paper: theme.modal__paper,
				title: theme.modal__title,
				content: theme.modal__content,
				buttons: theme.modal__buttons
			}}
			scroll="body"
			keepMounted={false}
			isOpen={isOpen}
			title={
				<>
					<CdnImage
						className={theme.emoji}
						path={'https://cdn.websky.aero/content/frontend/images/emojy/sorry.svg'}
						alt="sorry"
					/>

					{!!header && <span>{header}</span>}
				</>
			}
			onClose={onClose}
			onConfirm={onConfirm}
			onCancel={onCancel}
			confirmBtn={confirmBtn}
			cancelBtn={cancelBtn}
		>
			<div className={theme.content}>
				{showErrorInfo && (
					<div className={theme.errorInfo}>
						{title && <div className={theme.errorInfo__title}>{title}</div>}
						{message && <div className={theme.errorInfo__message}>{message}</div>}
					</div>
				)}

				{showDetails && (
					<div className={theme.details__wrapper}>
						{detailsTitle && <div className={theme.details__title}>{detailsTitle}</div>}

						<div className={theme.details__container}>
							<div className={theme.details}>
								{details?.map((detail, index) => (
									<span key={`${index}-${detail}`} className={theme.detail}>{`${
										detail.label ? `${detail.label}: ` : ''
									}${detail.value}`}</span>
								))}
							</div>

							<CopyButton className={theme.details__button} text={detailsText!} variant="text" />
						</div>

						{detailsDescription && <div className={theme.details__description}>{detailsDescription}</div>}
					</div>
				)}
			</div>
		</ModalConfirm>
	);
};

export default ErrorModal;
